import { AttachPerms_ExpiredLink } from './getReferenceAttachmentPermissionString.locstring.json';
import loc, { format } from 'owa-localize';

import { getAttachmentPermissionLevelString } from 'owa-attachment-permission';
import { isFeatureEnabled } from 'owa-feature-flags';
import { OwaDate, isBefore, now } from 'owa-datetime';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';

export default function getReferenceAttachmentPermissionString(
    permLevel: AttachmentPermissionLevel,
    providerType: string,
    expirationDate: OwaDate = null,
    isPlaceHolder: boolean = false
): string | null {
    // We show no string while attach is in progress, but otherwise AttachmentPermissionLevel.None
    // means that the user does not have permission to share the file.
    if (permLevel === null || permLevel === undefined || isPlaceHolder) {
        return null;
    }

    if (
        isFeatureEnabled('doc-attachment-referenceAttachmentExpiration') &&
        expirationDate &&
        isBefore(expirationDate, now())
    ) {
        return format(loc(AttachPerms_ExpiredLink), expirationDate);
    }

    return getAttachmentPermissionLevelString(permLevel, providerType);
}
